import { Button, dialog } from "nq-component";
import BaseListPresenter from "../../../../base/BaseListPresenter";
import {
  extractSalary,
  formattedRate,
  ServiceRecordLeave,
} from "../../../../components/common/Converter";
import { findObjectUseCase, upsertUseCase } from "../../../../usecases/object";

class HRActionPresenter extends BaseListPresenter {
  constructor(view) {
    super(view);
    this.view = view;
  }

  tableData(title, subtitle) {
    return (
      <tr>
        <th
          className="bg-light pt-3 pb-3 ps-4"
          style={{
            fontSize: "13px",
            border: "1px solid #d3d3d3",
          }}
        >
          {title}
        </th>
        <td
          className="ps-4"
          style={{
            fontSize: "13px",
            border: "1px solid #d3d3d3",
          }}
        >
          {subtitle}
        </td>
      </tr>
    );
  }

  handleClickOk() {
    if (this.view.state.submitting) return;

    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>Confirmation</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Are you sure you want to process this HR action?
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={this.view.dialogClose.bind(this)}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              progress={this.view.state.submitting}
              disabled={this.view.state.submitting}
              onClick={() => {
                if (this.view.state.submitting) return;
                this.confirmChanges();
              }}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  async confirmChanges() {
    this.view.submitting();
    dialog.close();
    try {
      const { object } = this.view.props;
      const { nonPlantillaSalary } = this.view.state;

      const empSalaryGrade = extractSalary(object?.salaryGrade ?? "0");
      const empPosition = object?.position?.position_title ?? "";
      const jobType = object?.employmentType?.name.toLowerCase().trim();
      // const employmentTypeId = object?.employmentType?.id;
      const isJobOrder = jobType === "job order";
      const id = !isJobOrder ? this.view.state.salaryPointer?.id : null;

      let salary_Grade = [];
      if (!isJobOrder && this.view.state.salaryPointer?.id) {
        salary_Grade = await findObjectUseCase().execute("salary_grade", {
          where: { id: id },
          keys: ["name", "Monthly Rate", "step", "salaryCode"],
        });
      }
      // const updateUser = await findObjectUseCase().execute("users", {
      //   where: { "employee.id": object.id },
      //   keys: ["serialNum", "removedSN"],
      // });

      let steps = "";
      let salaryCode = "";
      if(salary_Grade.length > 0) {
        steps = salary_Grade[0].Step;
        salaryCode = salary_Grade[0].salaryCode;
      }

      const selectedSalary =
        salary_Grade.length > 0
          ? `${salary_Grade[0].name} (₱ ${formattedRate(
              salary_Grade[0]["Monthly Rate"]
            )} per month)`
          : "";

      const nonPlantillaSG = nonPlantillaSalary
        ? `(₱ ${formattedRate(nonPlantillaSalary)} per month)`
        : "";

      const hierarchy = this.view.state.hierarchy;

      const updateEmployee = {
        step: steps,
        salaryCode,
        salaryGrade: isJobOrder ? nonPlantillaSG : selectedSalary,
        ...(isJobOrder
          ? { nonRegPosition: this.view.state.positionSelected }
          : { position: this.view.state.positionSelected }),
        ...(!isJobOrder && {
          salaryPointer: this.view.state.salaryPointer,
        }),
        oldSalaryGrade: empSalaryGrade,
        oldPositionTitle: empPosition,
        ...hierarchy,
        id: object.id,
      };

      delete updateEmployee.selectedSchedule;
      // console.log("updateEmployee", updateEmployee);
      // return;

      // if (updateUser.length > 0) {
      //   const usersQuery = this.getLastNonEmptyField(updateEmployee);
      //   const field = `${this.fields[usersQuery.index]}`;

      //   const devices = await findObjectUseCase().execute("devices", {
      //     where: {
      //       [field]: usersQuery.result,
      //     },
      //     keys: ["serialNum"],
      //   });

      //   // let removedSN = []; // Initialize as an empty array
      //   let removedSN = updateUser[0].serialNum;
      //   let newSerial = []; // Initialize as an empty array
      //   // if (oldSerial.length > 0) {
      //   //   oldSerial.forEach((old) => {
      //   //     removedSN.push(old.serialNum); // Add each item’s serialNum to the array
      //   //   });
      //   // }
      //   // let newSerial = []; // Initialize as an empty array
      //   if (devices.length > 0) {
      //     devices.forEach((item) => {
      //       newSerial.push(item.serialNum); // Add each item’s serialNum to the array
      //     });
      //   }

      //   // Filter out serial numbers in removedSN that exist in newSerial
      //   if (Array.isArray(removedSN)) {
      //     removedSN = removedSN.filter((serial) => !newSerial.includes(serial));
      //   }

      //   updateUser[0].serialNum = newSerial;
      //   updateUser[0].removedSN = removedSN;
      //   updateUser[0].isRemoved = true;
      //   await upsertUseCase().execute("users", updateUser[0]);
      //   await upsertUseCase().execute("employees", updateEmployee);
      //   this.insertServiceRecord(updateEmployee);
      //.view   this.dialogClose();
      //   this.view.props.closeHR();
      //   this.view.props.refetchData();
      //   this.view.showSuccess("Success");
      //   return;
      // }
      console.log("updateEmployee: ", updateEmployee);
      await upsertUseCase().execute("employees", updateEmployee);
      updateEmployee.email = object.email;
      this.insertServiceRecord(updateEmployee);
      this.view.props.closeHR();
      this.view.props.refetchData();
      this.view.showSuccess("Success");
    } catch (err) {
      console.error(" confirmChanges error:", err);
      this.view.submissionError();
    } finally {
      this.view.submissionSuccess();
    }
  }

  async insertServiceRecord(updateEmployee) {
    const effectivity = this.view.state.effectivityDate
      ? new Date(this.view.state.effectivityDate)
      : new Date();
    const serviceRec = await findObjectUseCase().execute("service_record", {
      where: { empID: updateEmployee?.id, to: { $exists: false } },
    });

    const dateFrom = serviceRec[0]?.from
      ? new Date(serviceRec[0]?.from)
      : new Date();
    dateFrom.setDate(dateFrom.getDate() - 1);
    const leaveReq = await findObjectUseCase().execute("leave_request", {
      where: {
        employee: { id: updateEmployee.id },
        stats: "Approved",
        categoryType: "Without Pay",
        $or: [
          { startdate: { $gte: dateFrom, $lte: effectivity } },
          { enddate: { $gte: dateFrom, $lte: effectivity } },
        ],
      },
    });

    console.log("PLANNING OFFICER IV: ", updateEmployee.salaryGrade);
    let salary = "";
    if (updateEmployee?.salaryGrade) {
      salary = updateEmployee?.salaryGrade.replace(
        /₱\s?([\d,]+\.\d{2})/,
        (_, num) => `₱ ${(parseFloat(num.replace(/,/g, "")) * 12).toFixed(2)}`
      );
    }
    console.log("PLANNING OFFICER IV: ", salary);

    const serviceLog = {
      email: updateEmployee?.email,
      empID: updateEmployee?.id,
      from: effectivity,
      employee: { id: updateEmployee.id },
      designation: this.view.state.selectedPosition,
      status: updateEmployee?.employmentType?.name || "",
      salary: salary,
      station: "BUREAU OF IMMIGRATION",
      branch: "NATIONAL",
      cause: this.view.state?.actiontype,
    };

    if (serviceRec.length > 0) {
      let leaveStatus = [];
      for (const leave of leaveReq) {
        // Extract and abbreviate the selectedType
        const selectedType = leave.selectedType;
        const abbreviation = selectedType
          .split(" ") // Split the string into an array of words
          .map((word) => word.charAt(0)) // Take the first letter of each word
          .join(""); // Join them back together

        // Format the startDate and endDate
        leaveStatus.push(
          ServiceRecordLeave(
            abbreviation,
            new Date(leave?.startdate),
            new Date(leave?.enddate)
          )
        ); // Add to the result array
      }

      const effectivity = new Date(serviceLog?.from);
      effectivity.setDate(effectivity.getDate() - 1);
      serviceRec[0].to = effectivity;
      serviceRec[0].leave = leaveStatus;
      serviceRec[0].status = serviceLog?.status;
      await upsertUseCase().execute("service_record", serviceRec[0]);
    }
    await upsertUseCase().execute("service_record", serviceLog);
  }
}
export default HRActionPresenter;
